// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"1011ffeead34ec0c","7364":"06446f1fead9fe40"}[chunkId] + ".css";
};